import { Alert, Typography } from '@mui/material';
import { Snackbar } from '@mui/material';
import { useEffect, useState, useMemo } from "react";
import ActionRenderer from "../components/ActionRenderer";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Dialog, DialogContent, DialogTitle, SpeedDial, SpeedDialAction, SpeedDialIcon, Button, DialogActions, Toolbar, AppBar, IconButton } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import AddIcon from '@mui/icons-material/Add';
import AddReport from "../components/AddReport";
import { getIntlTranslation } from "../../../utils/helper";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { miRoot } from "../../../utils/defaultValues";
import { useDispatch } from "react-redux";
import { createElement, getInspectionTemplate, getSiteDetails } from "../api/maintainenceInspectionApi";
import { useSelector } from "react-redux";
import { InfoOutlined, ViewModule, ViewList } from "@mui/icons-material";
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import ElementCard from "../components/ElementCard";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import Drawer from '@mui/material/Drawer';
import DefectList from '../components/DefectList';
import { fmtDE, getStatus } from '../utils/statusUtils';
import { useIntl } from 'react-intl';
import { DataGrid } from '@mui/x-data-grid';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const MISiteOverview = () => {

    const intl = useIntl();
    const language = useSelector((state) => state.system.language);

    const [successBanner, setSuccessBanner] = useState(false);
    const navigate = useNavigate()
    const location = useLocation();
    const { siteName, siteId } = useParams();
    const dispatch = useDispatch()

    const [openAddReport, setOpenAddReport] = useState(false)
    const [excel, setExcel] = useState(false)
    const [report, setReport] = useState(false)
    const [toggleView, setToggleView] = useState('grid');
    const [toggleDrawer, setToggleDrawer] = useState(false);
    const [drawerDefects, setDrawerDefects] = useState(null);
    const [addElement, setAddElement] = useState(false)

    const [rowToDelete, setRowToDelete] = useState(null);
    const [currentRow, setCurrentRow] = useState(null);
    const [siteInfo, setSiteInfo] = useState(null);

    const currentSiteId = siteId;

    const askDelete = (row) => setRowToDelete(row);
    const closeDelete = () => setRowToDelete(null);
    const confirmDelete = () => {
        if (rowToDelete) setRowData(prev => prev.filter(r => r.id !== rowToDelete.id));
        setRowToDelete(null);
    };

    const handleViewClick = (row) => {
        console.log(location.state?.site, 'helloo')
        setCurrentRow(row);
        // navigate(`${miRoot}/site-overview/${encodeURIComponent(siteName)}/${siteId}/protocols`, { state: { element: row , site:location.state.site} })
        navigate(`${miRoot}/site-overview/${siteId}/protocols`, { state: { element: row , site:location.state?.site} })
    }
    const [rowData, setRowData] = useState([]);
    useEffect(() => {
        console.log(`🔄 useEffect triggered - Fetching site details for ID: ${currentSiteId}`);
        
        if (currentSiteId) {
            console.log(`📡 API Call: getSiteDetails(${currentSiteId})`);
            dispatch(getSiteDetails(currentSiteId));
        } else {
            console.log('⚠️ No site ID available - skipping API call');
        }

        // Store site info from location.state if available  
        if (location.state?.site) {
            console.log('💾 Storing site info from navigation state:', location.state.site.name);
            setSiteInfo(location.state.site);
        } else {
            console.log('📭 No site info in navigation state');
        }
    }, [dispatch, currentSiteId, location.state]);

    const rows = useSelector((state) => state.maintainenceInspection?.siteDetails);
    useEffect(() => {
        const safeRows = Array.isArray(rows) ? rows : [];
        setRowData(safeRows);
    }, [rows]);

    const columns = useMemo(() => [
        {
            field: "id",
            headerName: intl.formatMessage({ id: "mi.id" }),
            headerClassName: "header-center",
            width: 90,
        },
        {
            field: "elementName",
            headerName: intl.formatMessage({ id: "mi.element-name" }),
            minWidth: 210,
        },
        {
            field: "lastInspectionDate",
            headerName: intl.formatMessage({ id: "mi.last-inspection" }),
            minWidth: 170,
            valueGetter: (params) =>
                params.row.lastInspectionDate ? fmtDE(params.row.lastInspectionDate) : "",
        },
        {
            field: "frequencyYears",
            headerName: intl.formatMessage({ id: "mi.frequency" }),
            minWidth: 140,
        },
        {
            field: "nextInspectionDate",
            headerName: "Next Inspection Date",
            valueGetter: (params) =>
                params.row.nextInspectionDate ? fmtDE(params.row.nextInspectionDate) : "",
            minWidth: 200,
        },
        {
            field: "defectsFound",
            headerName: intl.formatMessage({ id: "mi.defects-found" }),
            sortable: false,
            filterable: true,
            minWidth: 140,
            renderCell: (params) => {
                const text = params.row.defectsFound ?? "";
                const hasDefects = text && String(text).trim().length;
                const label = hasDefects
                    ? intl.formatMessage({ id: "mi.found" })
                    : intl.formatMessage({ id: "mi.not-found" });

                return (
                    <span style={{ color: "#6b7280", fontWeight: 600 }}>
                        {label}
                        {hasDefects ? (
                            <span
                                title={text}
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    setDrawerDefects(text);
                                    setCurrentRow(params.row);
                                    setToggleDrawer(true);
                                }}
                            >
                                <InfoOutlined
                                    style={{
                                        fontSize: 16,
                                        marginLeft: 4,
                                        verticalAlign: "middle",
                                    }}
                                />
                            </span>
                        ) : null}
                    </span>
                );
            },
        },
        {
            field: "status",
            headerName: intl.formatMessage({ id: "mi.status" }),
            minWidth: 140,
            valueGetter: (params) =>
                getStatus({
                    nextStr: params.row?.nextInspectionDate,
                    lastStr: params.row?.lastInspectionDate,
                    protocolUploaded: params.row?.protocolUploaded,
                }),
            renderCell: (params) => {
                const value = params.value;
                const color =
                    value === "upcoming"
                        ? "#ffc924"
                        : value === "overdue"
                            ? "#aa3939"
                            : "#97b444";

                return (
                    <span style={{ color }}>
                        {intl.formatMessage({ id: `mi.${value}` })}
                    </span>
                );
            },
        },
        {
            field: "reinspectionRequired",
            minWidth: 210,
            headerName: intl.formatMessage({ id: "mi.reinspection-required" }),
        },
        {
            field: "actions",
            headerName: intl.formatMessage({ id: "mi.actions" }),
            sortable: false,
            filterable: false,
            width: 160,
            renderCell: (params) => (
                <ActionRenderer
                    protocolsUploaded={params.row.protocolsUploaded}
                    onDelete={() => askDelete(params.row)}
                    handleViewCLick={() => handleViewClick(params.row)}
                />
            ),
        },
    ], [intl, language]);

    const handleAddExcel = () => {
        setOpenAddReport(true)
        setExcel(true)
        setReport(false)
        setAddElement(false)
    };

    const handleAddAssetAI = () => {
        setOpenAddReport(true)
        setExcel(false)
        setReport(true)
        setAddElement(false)
    };

    const handleAddElement = () => {
        setOpenAddReport(true)
        setExcel(false)
        setReport(false)
        setAddElement(true)
    }

    const handleAddReportSubmit = async (data) => {
        if (excel && Array.isArray(data)) {
            await Promise.all(
                data.map(row => {
                    console.log('row', row);
                    return dispatch(createElement({ data: row }));
                })
            );
        } else if (addElement) {
            await dispatch(createElement({ data }));
        }
        // Refresh site details after all submissions complete
        if (currentSiteId) {
            await dispatch(getSiteDetails(currentSiteId));
            console.log('Site details refreshed for site ID:', currentSiteId); 
        }
        // Show success banner
        setSuccessBanner(true);
    };
    return (
        <>
            <Box sx={{ margin: 1 }}>
                <Button
                    variant="none"
                    startIcon={<ArrowBackIcon />}
                    onClick={() => navigate(`${miRoot}`)}
                    sx={{ mb: 1, color: '#254a9a', borderColor: '#254a9a' }}
                >
                    {intl.formatMessage({ id: '_back' })}
                </Button>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'row', justifyContent: 'space-between', marginRight: 1, marginLeft: 1 }}>
                <Box>
                    <Typography variant="h5" sx={{ fontWeight: 600, color: '#254a9a' }}>
                       {location.state?.site?.name || rowData[0]?.site?.name}
                    </Typography>
                    <Typography variant="subtitle" sx={{ fontWeight: 600, mb: 2, opacity: 0.7 }}>
                        {location.state?.site?.street || rowData[0]?.site?.street}, {location.state?.site?.postalCode || rowData[0]?.site?.postalCode}, {location.state?.site?.city || rowData[0]?.site?.city}
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                    <ToggleButtonGroup
                        value={toggleView}
                        exclusive
                        onChange={(_, val) => { if (val) setToggleView(val); }}
                        size="small"
                        aria-label="toggle view"
                    >
                        <ToggleButton value="grid" aria-label="Grid View">
                            <ViewList sx={{ mr: 1 }} /> {intl.formatMessage({ id: "mi.grid" })}
                        </ToggleButton>
                        <ToggleButton value="card" aria-label="Card View">
                            <ViewModule sx={{ mr: 1 }} />  {intl.formatMessage({ id: "mi.card" })}
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Box>
            </Box>
            {toggleView === 'grid' ? (
                <Box sx={{ height: 'calc(100vh - 180px)', width: '100%' }}>
                    <DataGrid
                        rows={rowData || []}
                        columns={columns}
                        disableRowSelectionOnClick
                        pageSizeOptions={[10, 25, 50]}
                        initialState={{
                            pagination: {
                                paginationModel: { page: 0, pageSize: 25 },
                            },
                        }}
                        density="standard"
                    />
                </Box>
            ) : (
                <Box
                    sx={{
                        height: 'calc(100vh - 120px)',
                        overflowY: 'auto',
                        px: 2,
                        py: 3,
                    }}
                >
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
                            gap: 1.5,
                            justifyItems: 'start',
                            alignItems: 'start',
                        }}
                    >
                        {rowData.map((el) => (
                            <ElementCard key={el.id} element={el} handleViewClick={()=>handleViewClick(el)} />
                        ))}
                    </Box>
                </Box>
            )}
            <Drawer open={toggleDrawer} onClose={() => setToggleDrawer(false)} anchor="right" >
                <Box sx={{ width: 350, p: 2 }}>
                    <DefectList defects={drawerDefects} onClose={() => setToggleDrawer(false)} elementDetails={currentRow} />
                </Box>
            </Drawer>
            <Box sx={{ position: 'fixed', bottom: 40, right: 30, zIndex: 140 }}>
                <SpeedDial
                    ariaLabel="Add Options"
                    direction="up"
                    FabProps={{
                        sx: {
                            bgcolor: "#254a9a",
                            "&:hover": {
                                bgcolor: "#1e3d7a",
                            },
                        },
                    }}
                    icon={<SpeedDialIcon icon={<AddIcon sx={{ color: "#fff" }} />} />}>
                    <SpeedDialAction
                        icon={<DescriptionIcon />}
                        tooltipTitle={getIntlTranslation("mi.add-excel-file")}
                        onClick={handleAddExcel}
                    />
                    <SpeedDialAction
                        icon={<AutoAwesomeIcon />}
                        tooltipTitle={intl.formatMessage({ id: "mi.add-element-ai" })}
                        onClick={handleAddAssetAI}
                    />
                    <SpeedDialAction
                        icon={<FormatListBulletedIcon />}
                        tooltipTitle={intl.formatMessage({ id: "mi.add-element" })}
                        onClick={handleAddElement}
                    />
                </SpeedDial>
            </Box>
            <Dialog
                open={!!rowToDelete}
                onClose={closeDelete}
                fullWidth
                maxWidth="md"
                TransitionProps={{ unmountOnExit: true }}
                PaperProps={{ sx: { borderRadius: 2 } }}
            >
                <AppBar
                    className="appBar"
                    position="relative"
                    sx={{ bgcolor: "background.paper", color: "text.primary", }}
                >
                    <Toolbar className="dialog-toolbar" sx={{ display: "flex", justifyContent: "space-between", }}>
                        <DialogTitle>{getIntlTranslation("mi.delete-element")}</DialogTitle>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <IconButton
                                edge="end"
                                color="inherit"
                                aria-label="close"
                                onClick={closeDelete}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </Toolbar>
                </AppBar >
                <DialogContent>
                    {getIntlTranslation("mi.delete-confirmation")} “{rowToDelete?.elementName}”?
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeDelete}>{intl.formatMessage({ id: "cancel" })}</Button>
                    <Button onClick={confirmDelete} color="error" variant="contained">{intl.formatMessage({ id: "delete" })}</Button>
                </DialogActions>
            </Dialog>

            <Snackbar
                open={successBanner}
                autoHideDuration={4000}
                onClose={() => setSuccessBanner(false)}
                anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
            >
                <Alert onClose={() => setSuccessBanner(false)} severity="success" sx={{ width: '100%' }}>
                    Successfully added!
                </Alert>
            </Snackbar>

            {openAddReport ? <AddReport
                open={openAddReport}
                onClose={() => setOpenAddReport(false)}
                onSubmit={handleAddReportSubmit}
                onDownloadTemplate={() => {
                    dispatch(getInspectionTemplate())
                }}
                onUploaded={() => {
                    dispatch(getSiteDetails(siteId));
                }}
                excel={excel}
                report={report}
                siteId={siteId}
                elementList={rowData}
                addElement={addElement}
            /> : null}

        </>
    )
}

export default MISiteOverview